import IRouteProps from '@interfaces/RouteProps';
import { lazy } from 'react';

/** Document / tab title for public Trust Center unsubscribe (skipAuth; no BaseLayout). */
export const TRUST_CENTER_UNSUBSCRIBE_PAGE_TITLE = 'Trust Center — Unsubscribe';

const routes: IRouteProps[] = [
  {
    path: [
      '/profile-center/:profileId/:companyId/unsubscribe',
      '/profile-center/unsubscribe'
    ],
    component: lazy(() => import('@layouts/public/PublicTrustCenterUnsubscribe')),
    title: TRUST_CENTER_UNSUBSCRIBE_PAGE_TITLE,
    metricsPageName: 'Trust Center — Unsubscribe',
    moduleName: 'profile',
    menuModule: 'PROFILE',
    viewType: 'profile',
    skipAuth: true
  },
  {
    path: ['/profile-view/:companyId/docusign/callback'],
    component: lazy(() => import('@layouts/search/DocusignCallback')),
    title: 'Profile Center - Docusign Callback',
    metricsPageName: 'Profile Center - Docusign Callback',
    moduleName: 'profile',
    menuModule: 'PROFILE',
    viewType: 'profile',
    skipAuth: false,
    location: 'docusign'
  },
  {
    path: [
      '/profile-view/preview-content/:guestKey',
      '/profile-view/preview-content',
      '/profile-view/:profileId/preview-content/:guestKey',
      '/profile-center/:profileId/:companyId/preview-content',
      '/preview-content'
    ],
    component: lazy(() => import('@layouts/content/ContentRoot')),
    title: 'Profile Center - Preview Content',
    metricsPageName: 'Profile Center - Preview Content',
    moduleName: 'profile',
    menuModule: 'PROFILE',
    viewType: 'profile',
    skipAuth: false
  },
  {
    path: ['/profile-view/search', '/profile-center/:profileId/:companyId/search', '/search'],
    component: lazy(() => import('@layouts/search/SearchRoot')),
    title: 'Profile Center - Search',
    metricsPageName: 'Profile Center - Search',
    moduleName: 'profile',
    menuModule: 'PROFILE',
    viewType: 'profile',
    skipAuth: false
  },
  {
    path: ['/', '/profile-view/:guestKey', '/profile-view', '/profile-center/:profileId/:companyId', '/profile-center'],
    component: lazy(() => import('@layouts/profile/ProfileRoot')),
    title: 'Profile Center',
    metricsPageName: 'Profile Center',
    moduleName: 'profile',
    menuModule: 'PROFILE',
    viewType: 'profile',
    skipAuth: false
  }
];

export default routes;
